import React, { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react'

import './ErrorBoundary.scss'

type ErrorBoundaryProps = WithTranslation & {
  children: React.ReactNode
}

class ErrorBoundary extends Component<ErrorBoundaryProps> {  
  fallbackComponent = () => {
    const { t } = this.props

    return (
      <div className="error-boundary">
        {t('app.crushed')}
      </div> 
    )
  }

  render() {
    const { children } = this.props
    return (
      <Sentry.ErrorBoundary fallback={this.fallbackComponent()}>
        { children }
      </Sentry.ErrorBoundary>
    )
  }

}

export default withTranslation()(ErrorBoundary)